import React from "react";
import CardHome from "./CardHome.jsx";
import {routes} from "../../routes.js";
import Grid from '@mui/material/Grid';
import {Box} from "grommet";

const CardMenu=(props)=>{
    return(
    <Box margin="small" style={{overflowX:"hidden",height:"100%"}} >
         <Grid container spacing={{ xs: 12, sm: 12, md: 12 }} columns={{ xs: 1, sm: 8, md: 12 }} >
             {
                 routes.map((route,index)=>{
                     const Icon=route?.icon;
                     return(
                         route.visibleOnCardMenu && Array.isArray(route?.role) && route?.role.includes(props?.ruoli?.Ruolo) &&
                             <Grid item xs={2} sm={4} md={4} key={index}>
                                <CardHome key={index} name={route?.name} icon={<Icon style={{width:'100px',height:'100px'}} color="brand" />} onClick={()=> props?.setPage(route?.pageName || route?.name)} />
                            </Grid>
                     )
                 })
             }
         </Grid>
    </Box>
    )
}

export default CardMenu;